<template>
    <div>
        <b-row>
            <b-col cols="10">
                    <h4 v-if="checkFlag">Please configure Listening: High Light Incorrect Words.</h4>
                    <h4 v-else>Please select excel sheet for bulk question saving</h4>
                </b-col>
                <b-col cols="2">
                    <toggle-button :width="75" :height="28" v-model="checkFlag" :value="false" :color="{checked: '#104e94', unchecked: '#e9ecef', disabled: '#CCCCCC'}" :speed="500" :sync="true" :labels="{checked: 'enter', unchecked: 'load'}"/>
                </b-col>
            <b-form v-if="checkFlag" class="col-12"  @submit="onSubmit" @reset="onReset">
            <b-row>
                <b-col cols="6">
                    <label for="title">Enter Title</label>
                    <b-form-input v-model="highlightIncorrectWords.title" placeholder="Enter Question Title"></b-form-input>
                </b-col>
                <b-col cols="6">
                    <label for="mock_ind">Select Question Type</label>
                    <b-form-select v-model="highlightIncorrectWords.mock_ind" :options="dropdown"></b-form-select>
                </b-col>
            </b-row>
            <b-col cols="12">
                <div class="form-group">
                    <label for="textarea">Enter Correct Text</label>
                    <textarea spellcheck="false" v-model="highlightIncorrectWords.correct_para" class="form-control" id="textarea" rows="5"></textarea>
                </div>
            </b-col>
            <b-col cols="12">
                <div class="form-group">
                    <label for="textarea">Enter In Correct Text</label>
                    <textarea v-model="highlightIncorrectWords.question_para" class="form-control" id="textarea" rows="5"></textarea>
                </div>
            </b-col>
             <b-col class="col-12">
                    <label for="title">Select Audio</label>
                    <b-form-file
                        v-model="highlightIncorrectWords.question_recording"
                        :state="Boolean(highlightIncorrectWords.question_recording)"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        accept=".mp3,audio/*"
                        @change="onChange"
                        ></b-form-file>
                </b-col>
                <div class="col-6 displayInline" align="right">
                    <b-button type="submit" variant="primary" :disabled="allFilled != true">{{buttonText}}</b-button>
                </div>
                <div class="col-6 displayInline" align="left">
                    <b-button type="reset" variant="outline-danger">Reset</b-button>
                </div>
            </b-form>
        </b-row>
        <b-row  v-if="checkFlag" class="mt-4 ml-2 mr-2">
            <b-col cols="12">
                <b-alert
                :show="dismissCountDown"
                dismissible
                variant="outline-success"
                @dismissed="dismissCountDown=0"
                
                >
                Record saved successfully, dismiss in {{ dismissCountDown }} seconds...
                </b-alert>
            </b-col>
        </b-row>
        <b-row  v-if="checkFlag" class="mt-4 ml-2 mr-2">
            <b-col cols="12">
                <b-table
                    id="multipleChoiceSingle"
                    :items="allQuestions"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :fields="fields"
                    sort-icon-left
                    small
                    outlined
                    responsive
                    >
                    <template #cell(question_id)="data">
                    <!-- `data.value` is the value after formatted by the Formatter -->
                    <b-button variant="outline-warning" @click="deleteRecord(data.value)">
                        <b-icon icon="trash-fill"></b-icon>
                    </b-button>
                    <!-- <a href="#">{{data.value}}</a> -->
                </template>
                <template #cell(question_para)="data">
                    <!-- `data.value` is the value after formatted by the Formatter -->
                    <read-more class="readmoreDiv" more-str="read more" :text="data.value" link="#" less-str="read less" :max-chars="100"></read-more>
                    <!-- <p class="transcript">{{data.value}}</p> -->
                </template>
                </b-table>
            </b-col>
            <b-col cols="12">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="multipleChoiceSingle"
                    ></b-pagination>
            </b-col>
        </b-row>
        <div v-if="!checkFlag" class="row mt-4 ml-2 mr-2">
            <div class="col-12">
                
                <div class="form-group">
                    <label for="excelFile">Select Excel file</label>
                    <b-form-file
                        id="excelFile"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        accept=".xlsx"
                        @change="onFileChange"></b-form-file>
                </div>
            </div>
            <div class="col-12 text-center">
                <b-button :disabled="!fileLoad" @click="readFile()" class="mr-4">Read File</b-button>
                <b-button :disabled="!readFileFlag" variant="primary" @click="saveRecordExcel(1)">{{saveRecord}}</b-button>
            </div>
        </div>
        <div v-if="!checkFlag" class="row mt-4 ml-2 mr-2">
            <div class="col-12">
            <ul id="console-textarea" >
                <li v-for="(item,index) in consoleLog" :key="index">
                    {{item}}
                </li>
            </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions,mapGetters } from 'vuex'
import readXlsxFile from 'read-excel-file'
// import blobToBase64 from 'blob-to-base64'
export default {
    data(){
        return{
            buttonText:'Save',
            allFilled: false,
            dismissSecs: 5,
            dismissCountDown: 0,
            loadedFile:null,
            excelFile:null,
            fileLoad:false,
            checkFlag:true,
            readFileFlag:false,
            rowsLoadedArray:null,
            saveRecord:'Save Record',
            consoleLog:['Log Info.'],
            highlightIncorrectWords:{
                title:'',
                correct_para:'',
                question_para:'',
                question_recording: null,
                user_id:'1',
                time_slot:'02:00',
                mock_ind:'0'
            },
            allQuestions:null,
            perPage: 8,
            currentPage: 1,
            fields: [
            // {
            //     key: 'edit',
            //     label:'',
            //     sortable: false
            // },
            {
                key: 'question_id',
                label:'Delete',
                sortable: true
            },
            {
                key: 'title',
                label:'Title',
                sortable: false
            },
            {
                key: 'question_para',
                label: 'Description',
                sortable: true,
            }
            ],
            dropdown: [
                { value: '0', text: 'Please select an option' },
                { value: 'F', text: 'General' },
                { value: 'T', text: 'Mock Test' }
            ],
        }
    },
    methods:{
        ...mapActions({
            saveAnswer: 'listeningmodule/saveAnswer',
            saveQuestion:'listeningmodule/saveQuestion',
            questionservice: 'listeningmodule/fetchQuestion',
            fileUpload:'speakmodule/uploadFile',
            deleteQuestion:'writtingmodule/deleteQuestion'
        }),
        ...mapGetters({
            answerResponse: 'listeningmodule/AnswerResponse',
            getQuestionList: 'listeningmodule/questions'
        }),
        onFileChange(e) {
            const file = e.target.files[0];
            this.excelFile=file
            this.fileLoad =true
            this.readFileFlag=false
            this.consoleLog.push('Selected file loaded.')
            // this.loadedFile = e.target.files
            // this.fileUrl = URL.createObjectURL(file);
        },
        readFile(){
            if(this.excelFile!=null){
            readXlsxFile(this.excelFile).then((rows) => {
                            //console.log(rows)
                            this.consoleLog.push('Total records retrieve from excel sheet ' +rows.length +'.')
                            this.fileLoad =false
                            this.readFileFlag=true
                            this.rowsLoadedArray=rows
                        })
            }
        },
        saveRecordExcel(index){
            if(this.rowsLoadedArray==null)
            {
                return this.$alert('No record found')
            }
            else{
                let today = new Date().toLocaleDateString()
                var item=this.rowsLoadedArray[index]
                this.highlightIncorrectWords={
                    question_id:0,
                    title:item[1],
                    correct_para:item[3],
                    question_para:item[2],
                    question_recording: item[4],
                    new_ind:item[5],
                    user_id:'2',
                    predicted_ind:(item[6])?'Y':'N',
                    exam_ind:(item[7])?'Y':'N',
                    reading_slot_time:today,
                    speaking_slot_time:'00:40',
                    mock_ind:'F',
                    url:''
                }
                var findRecord=this.allQuestions.filter((item)=>{
                    return item.correct_para.trim().toLowerCase()==this.highlightIncorrectWords.correct_para.trim().toLowerCase()
                })[0]
                if(findRecord!=null){

                    var dte=new Date().toISOString().slice(0, 19).replace('T', ' ');
                    const param={
                            tableName:'tblListeningHighlightInCorrectWords',
                            idName:'question_id', 
                            id:findRecord.question_id,
                            predicted_ind:this.highlightIncorrectWords.predicted_ind,
                            predicted_date:dte,
                            exam_ind:this.highlightIncorrectWords.exam_ind,
                            title:this.highlightIncorrectWords.title,
                            exam_date:dte,
                            type:'single',
                            url:'updatequestion/status',
                        }
                        //console.log(param)
                        this.saveQuestion(param).then(()=>{
                            var resStatus = this.answerResponse()
                            this.consoleLog.push(resStatus.message)
                            if(index<this.rowsLoadedArray.length-1){
                            this.saveRecordExcel(index+1)
                            }
                        })
                }
                else {
                    this.highlightIncorrectWords.url='confighighlightincorrectwords/InsertBulkQuestion'
                
                this.saveQuestion(this.highlightIncorrectWords).then(()=>{
                        var res = this.answerResponse()
                        var id=res.data.insertId
                        var dte=new Date().toISOString().slice(0, 19).replace('T', ' ');
                        this.consoleLog.push(res.message)
                        const param={
                            tableName:'tblListeningHighlightInCorrectWords',
                            idName:'question_id', 
                            id:id,
                            predicted_ind:this.highlightIncorrectWords.predicted_ind,
                            question_recording:this.highlightIncorrectWords.question_recording,
                            predicted_date:dte,
                            exam_ind:this.highlightIncorrectWords.exam_ind,
                            title:this.highlightIncorrectWords.title,
                            exam_date:dte,
                            type:'single',
                            url:'updatequestion/status',
                        }
                        //console.log(param)
                        this.saveQuestion(param).then(()=>{
                            var resStatus = this.answerResponse()
                            this.consoleLog.push(resStatus.message)
                            this.consoleLog.push(this.highlightIncorrectWords.question_recording)
                            if(index<this.rowsLoadedArray.length-1){
                            this.saveRecordExcel(index+1)
                            }
                        })
                    });
                }
            }
        },
        onReset(evt) {
            evt.preventDefault()
            this.resetFrom()
        },
        resetFrom(){
            this.allFilled= false
            this.highlightIncorrectWords={
                title:'',
                correct_para:'',
                question_para:'',
                question_recording: null,
                user_id:'1',
                time_slot:'02:00',
                mock_ind:'0'
            }
        },
        onChange(e) { 
            this.loadedFile = e.target.files
        },
        onSubmit(evt) {
            evt.preventDefault()
           // var tempurl = URL.createObjectURL(this.highlightIncorrectWords.question_recording);
            this.highlightIncorrectWords.url = 'confighighlightincorrectwords/createquestion'
            var vm=this
             var data={
                fileName:'HICW--',
                files:this.loadedFile
            }
            //console.log(data)
            vm.highlightIncorrectWords.question_recording = 'Nothing'
                            vm.saveQuestion(vm.highlightIncorrectWords).then(()=>{
                                ////console.log(vm.answerResponse())
                                vm.userAnswerResponse = vm.answerResponse().data
                                vm.highlightIncorrectWords.question_id = vm.userAnswerResponse.insertId
                                data.fileName+= vm.userAnswerResponse.insertId
                                vm.fileUpload(data)
                                vm.allQuestions.push( vm.highlightIncorrectWords)
                                vm.$parent.getQuestionTypes();
                                vm.resetFrom();
                                vm.dismissCountDown = vm.dismissSecs
                                //alert('Data has been saved successfully.');
                            });
            // fetch(tempurl).then(function(response) {
            //     if(response.ok) {
            //         return response.blob();
            //     }
            //     else{
            //         throw new Error('Network response was not ok.');
            //     }
            //     }).then(function(blob) {
            //         blobToBase64(blob, function (error, base64) {
            //             if (!error) {
            //                 //////console.log(vm)
            //                 vm.highlightIncorrectWords.question_recording = base64
            //                 vm.saveQuestion(vm.highlightIncorrectWords).then(()=>{
            //                     ////console.log(vm.answerResponse())
            //                     vm.userAnswerResponse = vm.answerResponse().data
            //                     vm.highlightIncorrectWords.question_id = vm.userAnswerResponse.insertId
            //                     vm.allQuestions.push( vm.highlightIncorrectWords)
            //                     vm.$parent.getQuestionTypes();
            //                     vm.resetFrom();
            //                     vm.dismissCountDown = vm.dismissSecs
            //                     //alert('Data has been saved successfully.');
            //                 });
            //                 return base64;
            //             }
            //             else{
            //                 ////console.log(error)
            //             }
            //         });
            //     }).catch(function(error) {
            //     //console.log('There has been a problem with your fetch operation: ', error.message);
            //     });
        },
        addOption: function (ct) {
          const tempCt= {
            id:0,//this.options.length+1,
            optionText:'',
            add:true,
            correct:false
          }
          ct.add = false
          this.options.push(tempCt)
      },
      removeOption: function (index) {
          this.options.splice(index,1)
      },
      deleteRecord(id){
            var data={
                url:'confighighlightincorrectwords/deletequestion/id='+id
            }
            var vm = this
             this.deleteQuestion(data).then(()=>{
                vm.allQuestions = this.allQuestions.filter(function (item) {
                return item.question_id != id;
                })
                ////console.log(vm.allQuestions)
                vm.$parent.getQuestionTypes();
            });
            ////console.log(id)
        },

    },
    watch:{
        highlightIncorrectWords: {
            deep: true,
            handler () {
                this.allFilled = false
                if(this.highlightIncorrectWords.title !== '' & this.highlightIncorrectWords.correct_para !== '' & this.highlightIncorrectWords.question_para !== '')
                {
                    this.allFilled = true
                }
            }
        }
    },
    computed: {
      rows() {
          if(this.allQuestions == null){
              return 0
          }
          else{
              return this.allQuestions.length
          }
      }
    },
    beforeMount(){
        this.allQuestions = null
        this.questionservice('confighighlightincorrectwords/getAllQuestionsForGrid').then(()=>{
            this.allQuestions = this.getQuestionList().data
            ////console.log(this.allQuestions)
        })
    },
}
</script>

<style scoped>
textarea {
    height: 40vh;
    width: 100%;
    border: 1px solid #ccc;
    resize: none;
}
label
{
    margin-top: 10px;
text-transform: capitalize;
font-weight: 500;
}
.vue-js-switch{
    margin-top: 0px!important;
}
</style>
